import { FC, ReactNode } from "react";
import {
  StyledSelect,
  Selectrapper,
  StyledLabel,
  CheckBoxWrapper,
} from "./Select.styled";

type Props = {
  options: string[];
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  name: string;
  value: string;
  label?: string;
  required?: boolean;
  checkbox?: ReactNode;
  id?: string;
  placeholderOverWrite?: string;
};

const Select: FC<Props> = ({
  options,
  onChange,
  name,
  value,
  label,
  id,
  required,
  checkbox,
  placeholderOverWrite
}) => (
  <>
    <StyledLabel>
      {label}
      {required && <span> *</span>}
    </StyledLabel>
    <Selectrapper>
      <StyledSelect
        defaultValue=""
        name={name}
        value={value}
        onChange={onChange}
        id={id}
      >
        <option value="" disabled >
          { placeholderOverWrite ?  placeholderOverWrite : 'Please select'}
        </option>
        {options.map((option, i) => {
          return (
            <option key={i} value={option}>
              {option}
            </option>
          );
        })}
      </StyledSelect>
      {checkbox && <CheckBoxWrapper> {checkbox}</CheckBoxWrapper>}
    </Selectrapper>
  </>
);

export default Select;
